import React, { FC, MouseEvent } from 'react';
import classNames from 'classnames';

import getClassName from 'src/common/utils/getClassName';
import { validateRedirect } from '../../utils/routing';

import s from './CloseButton.module.scss';
import Icon from '../IconDS22';

/**
 * Requires `backUrl` or `onClick`.
 * Requires `className` or `classNameModifier`.
 */
type CloseButtonProps = {
  positionAbsolute?: boolean;
} & (
  | {
    backUrl: string;
    className?: never;
    classNameModifier?: string;
    onClick?: never;
  }
  | {
    backUrl?: never;
    className: string;
    classNameModifier?: never;
    onClick: (() => void) | ((e: MouseEvent<HTMLButtonElement>) => void);
  }
  | {
    backUrl: string;
    className: string;
    classNameModifier?: never;
    onClick?: never;
  }
  | {
    backUrl?: never;
    className?: never;
    classNameModifier?: string;
    onClick: (() => void) | ((e: MouseEvent<HTMLButtonElement>) => void);
  });

const CloseButton: FC<CloseButtonProps> = ({
  backUrl,
  className,
  classNameModifier,
  onClick,
  positionAbsolute = true,
}) => (
  <div className={className || getClassName(s, 'root', classNames(classNameModifier, { positionAbsolute }))}>
    {backUrl && (
      <a
        href={validateRedirect(backUrl)}
        aria-label="Close"
        className={getClassName(s, 'link', classNameModifier)}
      >
        <Icon id="x" size="l" />
      </a>
    )}
    {onClick && (
      <button
        type="button"
        onClick={onClick}
        aria-label="Close"
        className={getClassName(s, 'button', classNameModifier)}
      >
        <Icon id="x" size="l" />
      </button>
    )}
  </div>
);

export default CloseButton;
